import { Modal, Radio, Text } from '@beef/ui-kit';
import React, { useState } from 'react';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

import { ContentActions } from '../../../../../../../../components/Popups/CommonModal/components/ContentActions';
import { setModalVariant } from '../../../../actions';
import { useDispatch } from 'react-redux';

const cx = classNames.bind(styles);

export const MainStep = ({ data, isModalOpen }) => {
  const [variant, setVariant] = useState('');
  const dispatch = useDispatch();

  const {
    handleOnCloseModal,
    handlersMainBtn,
    isLoading,
    modalData,
    headerTitle,
    isDisabledMainBtn
  } = data;

  const handleOnChange = (value) => {
    setVariant(value);
    dispatch(setModalVariant(value));
  };

  return (
    <Modal
      size="s"
      onClose={handleOnCloseModal}
      isOpen={isModalOpen}
      isLoading={isLoading}
      headerBarConfig={{
        headerText: headerTitle,
      }}
      actionBar={
        !isLoading
          ? (
            <ContentActions
              onConfirm={handlersMainBtn?.main}
              onAdditionalConfirm={handlersMainBtn?.additional}
              data={modalData}
              isDisabledMainBtn={isDisabledMainBtn}
            />
          )
          : null
        }
    >
      <div className={cx('wrapper')}>
        {modalData?.mainInfo?.map((radioData) => (
          <div className={cx('controller-block')} key={`radio__${radioData?.value}`}>
            <div className={cx('controller-block__info')}>
              <Text size="size5-r-s">{radioData?.label}</Text>
              <Text size="size6-r" color="grey60">{radioData?.description}</Text>
            </div>
            <div className={cx('controller-block__radio')}>
              <Radio
                name={radioData?.value}
                radioVariant="default"
                value={radioData?.value}
                checked={variant === radioData?.value}
                onChange={(event) => handleOnChange(event.target?.value)}
              />
            </div>
          </div>
        ))}
      </div>

    </Modal>
  );
};
